//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import echarts from 'echarts'
export default {
  data(){
    return{
      ImgListLoading:false,
      tab:'first',
      value:true,
      hide:false,
      show:false,
      vpsInfo:{

      },
      stop:'close',
      netunit:'',
      state:'',
      ImgUrl:''
    }
  },
  created() {
    this.timer = setInterval(() => {
      this.VpsState()
      this.getVpsImg()
    }, 10000)
  },
  mounted() {
    this.VpsQuery()
    this.VpsState()
    this.getVpsImg()
  },
  beforeDestroy() {
    if(this.timer) { //如果定时器还在运行 或者直接关闭，不用判断
      clearInterval(this.timer); //关闭
    }
  },
  methods:{
    VpsQuery() {
      let data = 'cmd=vps_list'+
        '&id='+ this.$route.params.id
      this.$http.post('https://api.abeiyun.com/www/vps.php', data).then(({data}) => {
        if(data.response == 200) {
          this.vpsInfo = data.msg.content[0]
        }
      })
    },
    async VpsState() {
      let data = 'cmd=get_vps_state'+
        '&id='+ this.$route.params.id
      this.$http.post('https://api.abeiyun.com/www/vps.php', data).then(({data}) => {
        if(data) {
          this.state = data.msg
        }
      })
    },
    async getVpsImg() {
      this.ImgListLoading = true
      let data = 'cmd=getVpsImg'+
        '&id='+ this.$route.params.id
      this.$http.post('https://api.abeiyun.com/www/vps.php', data).then(({data}) => {
        if(data.response == 200) {
          this.ImgUrl = data.img.split('<img src=\'')[1].split('\' />')[0]
          this.ImgListLoading = false
        }
      })
    },
    Renew(id) {
      this.$router.push('/user/serverrenew/'+ id)
    },
    level(id,cpu,ram,ssd,net) {
      this.$router.push('/user/serverlevel/'+ id +'/'+ cpu +'/'+ ram +'/'+ ssd +'/'+ net)
    },
    Restart() {
      let _this = this
      this.$vux.confirm.show({
        title: '确认',
        content: '强制重启可能会导致未保存的数据丢失',

        onCancel () {
          console.log('plugin cancel')
        },
        onConfirm () {
          let data = 'cmd=vps_control'+
            '&id='+ _this.$route.params.id +
            '&cmd_type=reset'
          _this.$http.post('https://api.abeiyun.com/www/vps.php',data).then(({data})=>{
            if(data.response==200){
              _this.$vux.alert.show({
                title: '提示信息',
                content: data.msg,
                onHide () {

                }
              })
            }else{
              this.$vux.alert.show({
                title: '提示信息',
                content: data.msg,
              })
            }
          })
        }
      })
    },
    ChooseStop() {
      this.show = true
    },
    ResetPassword() {
      this.$router.push('/user/resetpassword/'+ this.$route.params.id +'/'+ this.vpsInfo.adminuser)
    },
    Reinstallserver() {
      this.$router.push('/user/reinstallserver/'+ this.$route.params.id)
    },
    Stop(type) {
      this.show = false
      let _this = this
      this.$vux.confirm.show({
        title: '确认',
        content: '确定要对该云服务器关机吗？',

        onCancel () {
          console.log('plugin cancel')
        },
        onConfirm () {
          let data = 'cmd=vps_control'+
            '&id='+ _this.$route.params.id +
            '&cmd_type=' + type
          _this.$http.post('https://api.abeiyun.com/www/vps.php',data).then(({data})=>{
            if(data.response==200){
              _this.$vux.alert.show({
                title: '提示信息',
                content: data.msg,
                onHide () {

                }
              })
            }else{
              this.$vux.alert.show({
                title: '提示信息',
                content: data.msg,
              })
            }
          })
        }
      })
    },
    Monitor() {
      this.tab = 'second'
      this.CpuLiuliang()
      this.IopsLiuliang()
      this.NetLiuliang()
    },
    CpuLiuliang() {
      let data = 'cmd=sys_report' +
        '&id='+ this.$route.params.id +
        '&cmd_type=cpu'
      this.$http.post('https://api.abeiyun.com/www/vps.php', data).then(({data}) => {
        if(data.response == 200) {
          let Cpu = echarts.init(document.getElementById('cpuChart'));
          let option = {
            tooltip: {
              trigger: 'axis',
              axisPointer: {
                type: 'cross',
                animation: false,
                label: {
                  backgroundColor: '#ccc',
                  borderColor: '#aaa',
                  borderWidth: 1,
                  shadowBlur: 0,
                  shadowOffsetX: 0,
                  shadowOffsetY: 0,
                  textStyle: {
                    color: '#222'
                  }
                }
              },
              formatter: function (params) {
                return params[0].name + '<br />' + 'CPU使用情况：' + params[0].value + '%'
              }
            },
            color:['#7CB5EC'],
            legend: {
              data:['CPU使用情况'],
              x: 'center',
              y: 'bottom'
            },
            grid: {
              top: '3%',
            },
            xAxis: {
              type: 'category',
              boundaryGap: false,
              data: data.msg.map((item, index) => {
                /*if(type === 'lastmonth' || type === 'month'){
                  return item.setdate
                }
                if(type === 'lastday'){
                  return item.cur_hour + '时'
                }*/
                return item.logtime
              }),
            },
            yAxis: {
              type: 'value',
              axisLabel: {
                formatter: '{value}'+ '%'
              }
            },
            series: [
              {
                name:'CPU使用情况',
                data: data.msg.map((item, index) => {
                  return item.cpu
                }),
                itemStyle : {
                  normal : {
                    lineStyle:{
                      color:'#7CB5EC'
                    }
                  }
                },
                type: 'line',
                smooth: true,
                areaStyle: {normal: {color:'#7CB5EC'}}
              },
            ]
          };
          Cpu.setOption(option)
        }else {
          this.$vux.alert.show({
            title: '提示信息',
            content: data.msg,
          })
        }
      })
    },
    IopsLiuliang() {
      let data = 'cmd=sys_report' +
        '&id='+ this.$route.params.id +
        '&cmd_type=cpu'
      this.$http.post('https://api.abeiyun.com/www/vps.php', data).then(({data}) => {
        if(data.response == 200) {
          let Iops = echarts.init(document.getElementById('iops'));
          let option = {
            tooltip: {
              trigger: 'axis',
              axisPointer: {
                type: 'cross',
                animation: false,
                label: {
                  backgroundColor: '#ccc',
                  borderColor: '#aaa',
                  borderWidth: 1,
                  shadowBlur: 0,
                  shadowOffsetX: 0,
                  shadowOffsetY: 0,
                  textStyle: {
                    color: '#222'
                  }
                }
              },
              formatter: function (params) {
                if(params.length == 2){
                  return params[0].name + '<br />' + '写入IOPS：' + params[0].value + '<br />' + '读取IOPS：' + params[1].value;
                }
                if(params.length == 1){
                  if(params[0].seriesName === '写入IOPS'){
                    return params[0].name + '<br />' + '写入IOPS：' + params[0].value;
                  }
                  if(params[0].seriesName === '读取IOPS'){
                    return params[0].name + '<br />' + '读取IOPS：' + params[0].value;
                  }
                }
              }
            },
            color:['#7CB5EC','#434348'],
            legend: {
              data:['写入IOPS','读取IOPS'],
              x: 'center',
              y: 'bottom'
            },
            grid: {
              top: '3%',
            },
            xAxis: {
              type: 'category',
              boundaryGap: false,
              data: data.msg.map((item, index) => {
                /*if(type === 'lastmonth' || type === 'month'){
                  return item.setdate
                }
                if(type === 'lastday'){
                  return item.cur_hour + '时'
                }*/
                return item.logtime
              }),
            },
            yAxis: {
              type: 'value',
            },
            series: [
              {
                name:'写入IOPS',
                data: data.msg.map((item, index) => {
                  return item.writeiops
                }),
                itemStyle : {
                  normal : {
                    lineStyle:{
                      color:'#7CB5EC'
                    }
                  }
                },
                type: 'line',
                smooth: true,
                areaStyle: {normal: {color:'#7CB5EC'}}
              },
              {
                name:'读取IOPS',
                data: data.msg.map((item, index) => {
                  return item.readiops
                }),
                itemStyle : {
                  normal : {
                    lineStyle:{
                      color:'#434348'
                    }
                  }
                },
                type: 'line',
                smooth: true,
                areaStyle: {normal: {color:'#434348'}}
              },
            ]
          };
          Iops.setOption(option)
        }else {
          this.$vux.alert.show({
            title: '提示信息',
            content: data.msg,
          })
        }
      })
    },
    NetLiuliang() {
      let data = 'cmd=sys_report' +
        '&id='+ this.$route.params.id +
        '&cmd_type=net'
      this.$http.post('https://api.abeiyun.com/www/vps.php', data).then(({data}) => {
        if(data.response == 200) {
          //计算单位
          let minuavgunit = this.bpsToSize2(data.minu.length > 0 ? (this.getiavgMax(data.minu) > this.getoavgMax(data.minu) ? this.getiavgMax(data.minu) : this.getoavgMax(data.minu)) : '')
          this.netunit = minuavgunit
          let netMinu = echarts.init(document.getElementById('netMinu'));
          let optionMinu = {
            tooltip: {
              trigger: 'axis',
              axisPointer: {
                type: 'cross',
                animation: false,
                label: {
                  backgroundColor: '#ccc',
                  borderColor: '#aaa',
                  borderWidth: 1,
                  shadowBlur: 0,
                  shadowOffsetX: 0,
                  shadowOffsetY: 0,
                  textStyle: {
                    color: '#222'
                  }
                }
              },
              formatter: function (params) {
                if(params.length == 2){
                  return params[0].name + '<br />' + '流入带宽：' + params[0].value + params[0].data.unit + '<br />' + '流出带宽：' + params[1].value + params[1].data.unit;
                }
                if(params.length == 1){
                  if(params[0].seriesName === '流入带宽'){
                    return params[0].name + '<br />' + '流入带宽：' + params[0].value + params[0].data.unit;
                  }
                  if(params[0].seriesName === '流出带宽'){
                    return params[0].name + '<br />' + '流出带宽：' + params[0].value + params[0].data.unit;
                  }
                }
              }
            },
            color:['#7CB5EC','#434348'],
            legend: {
              data:['流入带宽','流出带宽'],
              x: 'center',
              y: 'bottom'
            },
            grid: {
              left: '14%',
              top: '3%',
            },
            xAxis: {
              type: 'category',
              boundaryGap: false,
              data: data.minu.map((item, index) => {
                /*if(type === 'lastmonth' || type === 'month'){
                  return item.setdate
                }
                if(type === 'lastday'){
                  return item.cur_hour + '时'
                }*/
                return item.time
              }),
            },
            yAxis: {
              type: 'value',
              axisLabel: {
                formatter: '{value}'+ ( minuavgunit )
              }
            },
            series: [
              {
                name:'流入带宽',
                data: data.minu.map((item, index) => {
                  return {
                    value:this.bpsToSize(item.i_f_all_avg,minuavgunit),
                    unit:minuavgunit
                  }
                }),
                itemStyle : {
                  normal : {
                    lineStyle:{
                      color:'#7CB5EC'
                    }
                  }
                },
                type: 'line',
                smooth: true,
                areaStyle: {normal: {color:'#7CB5EC'}}
              },
              {
                name:'流出带宽',
                data: data.minu.map((item, index) => {
                  return {
                    value:this.bpsToSize(item.o_f_all_avg,minuavgunit),
                    unit:minuavgunit
                  }
                }),
                itemStyle : {
                  normal : {
                    lineStyle:{
                      color:'#434348'
                    }
                  }
                },
                type: 'line',
                smooth: true,
                areaStyle: {normal: {color:'#434348'}}
              },
            ]
          };
          netMinu.setOption(optionMinu)
        }else {
          this.$vux.alert.show({
            title: '提示信息',
            content: data.msg,
          })
        }
      })
    },
    bpsToSize(bps,unit) {
      if (bps === 0) return '0';
      bps = bps*8
      let k = 1024,i = 0;
      if(unit == 'bps'){
        i = 0
      }
      if(unit == 'Kbps'){
        i = 1
      }
      if(unit == 'Mbps'){
        i = 2
      }
      return (bps / Math.pow(k, i)) > 1 ? (bps / Math.pow(k, i)).toPrecision(4) : (bps / Math.pow(k, i)).toFixed(4);
    },
    bpsToSize2(bps) {
      if (bps === '') return '';
      if (bps === 0) return 'bps';
      bps = bps*8
      var k = 1024, // or 1024
        sizes = ['bps','Kbps', 'Mbps'],
        i = Math.floor(Math.log(bps) / Math.log(k));

      return sizes[i];
    },
    getiavgMax(arr){
      let max = arr[0].i_f_all_avg
      for(let x in arr){
        if(arr[x].i_f_all_avg > max){
          max = arr[x].i_f_all_avg
        }
      }
      return max
    },
    getoavgMax(arr){
      let max = arr[0].o_f_all_avg
      for(let x in arr){
        if(arr[x].o_f_all_avg > max){
          max = arr[x].o_f_all_avg
        }
      }
      return max
    },
  }
}



// WEBPACK FOOTER //
// ./src/components/console/server.vue